import { Injectable } from '@angular/core'
import { ICalendarSelection } from './calendar-selection'
import { HelperService } from '../../services/helper.service'
import { ICalendarLevel } from './calendar-level'
import { CalendarMonthsShortLabelEnum } from './calendar-months-label.enum'
import { IComplexDatepickerModel } from '../complex-datepicker/complex-datepicker.model'

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  constructor() {}

  public getDefaultMonthsLevel(): ICalendarLevel[] {
    const monthsLevel: ICalendarLevel[] = []
    const year: number = new Date().getFullYear()
    const month: number = new Date().getMonth() + 1
    for (let i = 0; i < 12; i++) {
      let _year: number = year
      let _month: number = month - i
      if (_month <= 0) {
        _month = 12 + _month
        _year--
      }
      monthsLevel.push({
        label: this.getMonthLabel(_month, _year),
        level: { year: _year, month: _month },
        info: `${_year}`,
      })
    }
    return monthsLevel
  }

  public getDefaultDaysLevel(year: number, month: number): ICalendarLevel[] {
    const daysLevel: ICalendarLevel[] = []
    const noOfDays = HelperService.getNoOfDaysFromMonthOfYear(year, month) // new Date(year, month, 0).getDate()
    for (let i = 1; i <= noOfDays; i++) {
      daysLevel.push({ label: `${i}`, level: { year: year, month: month, day: i } })
    }
    return daysLevel
  }

  public getDefaultHoursLevel(year: number, month: number, day: number): ICalendarLevel[] {
    const hoursLevel: ICalendarLevel[] = []
    for (let i = 0; i <= 23; i++) {
      hoursLevel.push({
        label: i < 10 ? `0${i}:00` : `${i}:00`,
        level: { year: year, month: month, day: day, hour: i },
      })
    }
    return hoursLevel
  }

  public getMonthLabel(m: number, y: number): string {
    const mm: string = `m${m}`
    if (mm in CalendarMonthsShortLabelEnum) {
      return `${CalendarMonthsShortLabelEnum[mm]} ${y}`
    }
    return ''
  }

  public getRangeDatesByCalendar(calendar: ICalendarSelection): Date[] {
    const params: Date[] = []
    const year: string = calendar.year ? `${calendar.year}` : null
    const month: string = !HelperService.isNullOrUndefined(calendar.month)
      ? parseInt(calendar.month.toString(), 0) < 10
        ? `0${calendar.month}`
        : `${calendar.month}`
      : null
    const day: string = !HelperService.isNullOrUndefined(calendar.day)
      ? parseInt(calendar.day.toString(), 0) < 10
        ? `0${calendar.day}`
        : `${calendar.day}`
      : null
    const hour: string = !HelperService.isNullOrUndefined(calendar.hour)
      ? parseInt(calendar.hour.toString(), 0) < 10
        ? `0${calendar.hour}`
        : `${calendar.hour}`
      : null
    let current: Date
    let next: Date

    if (year !== null && month !== null && day !== null && hour !== null) {
      current = new Date(Date.parse(`${year}-${month}-${day}T${hour}:00:00.000`))
      next = new Date(Date.parse(`${year}-${month}-${day}T${hour}:00:00.000`))
      next.setHours(next.getHours() + 1)
      next.setSeconds(next.getSeconds() - 1)
    } else if (year !== null && month !== null && day !== null) {
      current = new Date(Date.parse(`${year}-${month}-${day}T00:00:00.000`))
      next = new Date(Date.parse(`${year}-${month}-${day}T00:00:00.000`))
      next.setDate(next.getDate() + 1)
      next.setSeconds(next.getSeconds() - 1)
    } else if (year !== null && month !== null) {
      current = new Date(Date.parse(`${year}-${month}-01T00:00:00.000`))
      next = new Date(Date.parse(`${year}-${month}-01T00:00:00.000`))
      next.setMonth(next.getMonth() + 1)
      next.setSeconds(next.getSeconds() - 1)
    }
    if (current && next) {
      params.push(current)
      params.push(next)
    }
    return params
  }

  public isDatePickerTimeDifferentThanCalendar(
    calendar: ICalendarSelection,
    datePicker: IComplexDatepickerModel,
  ): boolean {
    if (datePicker['type'] && datePicker['type'] === 'D') {
      if (datePicker['dates'] && datePicker['dates']['start'] && datePicker['dates']['end']) {
        const sd: Date = new Date(Date.parse(datePicker['dates']['start']))
        const ed: Date = new Date(Date.parse(datePicker['dates']['end']))
        const range: Date[] = this.getRangeDatesByCalendar(calendar)
        if (range.length === 2) {
          if (sd.getTime() === range[0].getTime() && ed.getTime() === range[1].getTime()) {
            return false
          }
        }
      }
    }
    return true
  }
}
